module.exports = __webpack_public_path__ + "img/nuovo-impianto.601df8d0.jpg";